export default [
    { id: 'Afghanistan', text: 'Afghanistan' },
    { id: 'Albania', text: 'Albania' },
    { id: 'Algeria', text: 'Algeria' },
    { id: 'American Samoa', text: 'American Samoa' },
    { id: 'Andorra', text: 'Andorra' },
    { id: 'Angola', text: 'Angola' },
    { id: 'Anguilla', text: 'Anguilla' },
    { id: 'Antarctica', text: 'Antarctica' },
    { id: 'Antigua and Barbuda', text: 'Antigua and Barbuda' },
    { id: 'Argentina', text: 'Argentina' },
    { id: 'Armenia', text: 'Armenia' },
    { id: 'Aruba', text: 'Aruba' },
    { id: 'Australia', text: 'Australia' },
    { id: 'Austria', text: 'Austria' },
    { id: 'Azerbaijan', text: 'Azerbaijan' },
    { id: 'Bahamas', text: 'Bahamas' },
    { id: 'Bahrain', text: 'Bahrain' },
    { id: 'Bangladesh', text: 'Bangladesh' },
    { id: 'Barbados', text: 'Barbados' },
    { id: 'Belarus', text: 'Belarus' },
    { id: 'Belgium', text: 'Belgium' },
    { id: 'Belize', text: 'Belize' },
    { id: 'Benin', text: 'Benin' },
    { id: 'Bermuda', text: 'Bermuda' },
    { id: 'Bhutan', text: 'Bhutan' },
    { id: 'Bolivia', text: 'Bolivia' },
    { id: 'Bosnia and Herzegowina', text: 'Bosnia and Herzegowina' },
    { id: 'Botswana', text: 'Botswana' },
    { id: 'Bouvet Island', text: 'Bouvet Island' },
    { id: 'Brazil', text: 'Brazil' },
    { id: 'British Indian Ocean Territory', text: 'British Indian Ocean Territory' },
    { id: 'Brunei Darussalam', text: 'Brunei Darussalam' },
    { id: 'Bulgaria', text: 'Bulgaria' },
    { id: 'Burkina Faso', text: 'Burkina Faso' },
    { id: 'Burundi', text: 'Burundi' },
    { id: 'Cambodia', text: 'Cambodia' },
    { id: 'Cameroon', text: 'Cameroon' },
    { id: 'Canada', text: 'Canada' },
    { id: 'Cape Verde', text: 'Cape Verde' },
    { id: 'Cayman Islands', text: 'Cayman Islands' },
    { id: 'Central African Republic', text: 'Central African Republic' },
    { id: 'Chad', text: 'Chad' },
    { id: 'Chile', text: 'Chile' },
    { id: 'China', text: 'China' },
    { id: 'Christmas Island', text: 'Christmas Island' },
    { id: 'Cocos (Keeling) Islands', text: 'Cocos (Keeling) Islands' },
    { id: 'Colombia', text: 'Colombia' },
    { id: 'Comoros', text: 'Comoros' },
    { id: 'Congo', text: 'Congo' },
    { id: 'Congo, the Democratic Republic of the',
        text: 'Congo, the Democratic Republic of the' },
    { id: 'Cook Islands', text: 'Cook Islands' },
    { id: 'Costa Rica', text: 'Costa Rica' },
    { id: `Cote d'Ivoire`, text: `Cote d'Ivoire` },
    { id: 'Croatia (Hrvatska)', text: 'Croatia (Hrvatska)' },
    { id: 'Cuba', text: 'Cuba' },
    { id: 'Cyprus', text: 'Cyprus' },
    { id: 'Czech Republic', text: 'Czech Republic' },
    { id: 'Denmark', text: 'Denmark' },
    { id: 'Djibouti', text: 'Djibouti' },
    { id: 'Dominica', text: 'Dominica' },
    { id: 'Dominican Republic', text: 'Dominican Republic' },
    { id: 'East Timor', text: 'East Timor' },
    { id: 'Ecuador', text: 'Ecuador' },
    { id: 'Egypt', text: 'Egypt' },
    { id: 'El Salvador', text: 'El Salvador' },
    { id: 'Equatorial Guinea', text: 'Equatorial Guinea' },
    { id: 'Eritrea', text: 'Eritrea' },
    { id: 'Estonia', text: 'Estonia' },
    { id: 'Ethiopia', text: 'Ethiopia' },
    { id: 'Falkland Islands (Malvinas)', text: 'Falkland Islands (Malvinas)' },
    { id: 'Faroe Islands', text: 'Faroe Islands' },
    { id: 'Fiji', text: 'Fiji' },
    { id: 'Finland', text: 'Finland' },
    { id: 'France', text: 'France' },
    { id: 'France, Metropolitan', text: 'France, Metropolitan' },
    { id: 'French Guiana', text: 'French Guiana' },
    { id: 'French Polynesia', text: 'French Polynesia' },
    { id: 'French Southern Territories', text: 'French Southern Territories' },
    { id: 'Gabon', text: 'Gabon' },
    { id: 'Gambia', text: 'Gambia' },
    { id: 'Georgia', text: 'Georgia' },
    { id: 'Germany', text: 'Germany' },
    { id: 'Ghana', text: 'Ghana' },
    { id: 'Gibraltar', text: 'Gibraltar' },
    { id: 'Greece', text: 'Greece' },
    { id: 'Greenland', text: 'Greenland' },
    { id: 'Grenada', text: 'Grenada' },
    { id: 'Guadeloupe', text: 'Guadeloupe' },
    { id: 'Guam', text: 'Guam' },
    { id: 'Guatemala', text: 'Guatemala' },
    { id: 'Guinea', text: 'Guinea' },
    { id: 'Guinea-Bissau', text: 'Guinea-Bissau' },
    { id: 'Guyana', text: 'Guyana' },
    { id: 'Haiti', text: 'Haiti' },
    { id: 'Heard and Mc Donald Islands', text: 'Heard and Mc Donald Islands' },
    { id: 'Holy See (Vatican City State)', text: 'Holy See (Vatican City State)' },
    { id: 'Honduras', text: 'Honduras' },
    { id: 'Hong Kong', text: 'Hong Kong' },
    { id: 'Hungary', text: 'Hungary' },
    { id: 'Iceland', text: 'Iceland' },
    { id: 'India', text: 'India' },
    { id: 'Indonesia', text: 'Indonesia' },
    { id: 'Iran (Islamic Republic of)', text: 'Iran (Islamic Republic of)' },
    { id: 'Iraq', text: 'Iraq' },
    { id: 'Ireland', text: 'Ireland' },
    { id: 'Israel', text: 'Israel' },
    { id: 'Italy', text: 'Italy' },
    { id: 'Jamaica', text: 'Jamaica' },
    { id: 'Japan', text: 'Japan' },
    { id: 'Jordan', text: 'Jordan' },
    { id: 'Kazakhstan', text: 'Kazakhstan' },
    { id: 'Kenya', text: 'Kenya' },
    { id: 'Kiribati', text: 'Kiribati' },
    { id: `Korea, Democratic People's Republic of`,
        text: `Korea, Democratic People's Republic of` },
    { id: 'Korea, Republic of', text: 'Korea, Republic of' },
    { id: 'Kuwait', text: 'Kuwait' },
    { id: 'Kyrgyzstan', text: 'Kyrgyzstan' },
    { id: `Lao People's Democratic Republic`, 
        text: `Lao People's Democratic Republic` },
    { id: 'Latvia', text: 'Latvia' },
    { id: 'Lebanon', text: 'Lebanon' },
    { id: 'Lesotho', text: 'Lesotho' },
    { id: 'Liberia', text: 'Liberia' },
    { id: 'Libyan Arab Jamahiriya', text: 'Libyan Arab Jamahiriya' },
    { id: 'Liechtenstein', text: 'Liechtenstein' },
    { id: 'Lithuania', text: 'Lithuania' },
    { id: 'Luxembourg', text: 'Luxembourg' },
    { id: 'Macau', text: 'Macau' },
    { id: 'Macedonia, The Former Yugoslav Republic of',
        text: 'Macedonia, The Former Yugoslav Republic of' },
    { id: 'Madagascar', text: 'Madagascar' },
    { id: 'Malawi', text: 'Malawi' },
    { id: 'Malaysia', text: 'Malaysia' },
    { id: 'Maldives', text: 'Maldives' },
    { id: 'Mali', text: 'Mali' },
    { id: 'Malta', text: 'Malta' },
    { id: 'Marshall Islands', text: 'Marshall Islands' },
    { id: 'Martinique', text: 'Martinique' },
    { id: 'Mauritania', text: 'Mauritania' },
    { id: 'Mauritius', text: 'Mauritius' },
    { id: 'Mayotte', text: 'Mayotte' },
    { id: 'Mexico', text: 'Mexico' },
    { id: 'Micronesia, Federated States of', text: 'Micronesia, Federated States of' },
    { id: 'Moldova, Republic of', text: 'Moldova, Republic of' },
    { id: 'Monaco', text: 'Monaco' },
    { id: 'Mongolia', text: 'Mongolia' },
    { id: 'Montserrat', text: 'Montserrat' },
    { id: 'Morocco', text: 'Morocco' },
    { id: 'Mozambique', text: 'Mozambique' },
    { id: 'Myanmar', text: 'Myanmar' },
    { id: 'Namibia', text: 'Namibia' },
    { id: 'Nauru', text: 'Nauru' },
    { id: 'Nepal', text: 'Nepal' },
    { id: 'Netherlands', text: 'Netherlands' },
    { id: 'Netherlands Antilles', text: 'Netherlands Antilles' },
    { id: 'New Caledonia', text: 'New Caledonia' },
    { id: 'New Zealand', text: 'New Zealand' },
    { id: 'Nicaragua', text: 'Nicaragua' },
    { id: 'Niger', text: 'Niger' },
    { id: 'Nigeria', text: 'Nigeria' },
    { id: 'Niue', text: 'Niue' },
    { id: 'Norfolk Island', text: 'Norfolk Island' },
    { id: 'Northern Mariana Islands', text: 'Northern Mariana Islands' },
    { id: 'Norway', text: 'Norway' },
    { id: 'Oman', text: 'Oman' },
    { id: 'Pakistan', text: 'Pakistan' },
    { id: 'Palau', text: 'Palau' },
    { id: 'Panama', text: 'Panama' },
    { id: 'Papua New Guinea', text: 'Papua New Guinea' },
    { id: 'Paraguay', text: 'Paraguay' },
    { id: 'Peru', text: 'Peru' },
    { id: 'Philippines', text: 'Philippines' },
    { id: 'Pitcairn', text: 'Pitcairn' },
    { id: 'Poland', text: 'Poland' },
    { id: 'Portugal', text: 'Portugal' },
    { id: 'Puerto Rico', text: 'Puerto Rico' },
    { id: 'Qatar', text: 'Qatar' },
    { id: 'Reunion', text: 'Reunion' },
    { id: 'Romania', text: 'Romania' },
    { id: 'Russian Federation', text: 'Russian Federation' },
    { id: 'Rwanda', text: 'Rwanda' },
    { id: 'Saint Kitts and Nevis', text: 'Saint Kitts and Nevis' },
    { id: 'Saint LUCIA', text: 'Saint LUCIA' },
    { id: 'Saint Vincent and the Grenadines', text: 'Saint Vincent and the Grenadines' },
    { id: 'Samoa', text: 'Samoa' },
    { id: 'San Marino', text: 'San Marino' },
    { id: 'Sao Tome and Principe', text: 'Sao Tome and Principe' },
    { id: 'Saudi Arabia', text: 'Saudi Arabia' },
    { id: 'Senegal', text: 'Senegal' },
    { id: 'Seychelles', text: 'Seychelles' },
    { id: 'Sierra Leone', text: 'Sierra Leone' },
    { id: 'Singapore', text: 'Singapore' },
    { id: 'Slovakia (Slovak Republic)', text: 'Slovakia (Slovak Republic)' },
    { id: 'Slovenia', text: 'Slovenia' },
    { id: 'Solomon Islands', text: 'Solomon Islands' },
    { id: 'Somalia', text: 'Somalia' },
    { id: 'South Africa', text: 'South Africa' },
    { id: 'South Georgia and the South Sandwich Islands',
        text: 'South Georgia and the South Sandwich Islands' },
    { id: 'Spain', text: 'Spain' },
    { id: 'Sri Lanka', text: 'Sri Lanka' },
    { id: 'St. Helena', text: 'St. Helena' },
    { id: 'St. Pierre and Miquelon', text: 'St. Pierre and Miquelon' },
    { id: 'Sudan', text: 'Sudan' },
    { id: 'Suriname', text: 'Suriname' },
    { id: 'Svalbard and Jan Mayen Islands', text: 'Svalbard and Jan Mayen Islands' },
    { id: 'Swaziland', text: 'Swaziland' },
    { id: 'Sweden', text: 'Sweden' },
    { id: 'Switzerland', text: 'Switzerland' },
    { id: 'Syrian Arab Republic', text: 'Syrian Arab Republic' },
    { id: 'Taiwan, Province of China', text: 'Taiwan, Province of China' },
    { id: 'Tajikistan', text: 'Tajikistan' },
    { id: 'Tanzania, United Republic of', text: 'Tanzania, United Republic of' },
    { id: 'Thailand', text: 'Thailand' },
    { id: 'Togo', text: 'Togo' },
    { id: 'Tokelau', text: 'Tokelau' },
    { id: 'Tonga', text: 'Tonga' },
    { id: 'Trinidad and Tobago', text: 'Trinidad and Tobago' },
    { id: 'Tunisia', text: 'Tunisia' },
    { id: 'Turkey', text: 'Turkey' },
    { id: 'Turkmenistan', text: 'Turkmenistan' },
    { id: 'Turks and Caicos Islands', text: 'Turks and Caicos Islands' },
    { id: 'Tuvalu', text: 'Tuvalu' },
    { id: 'Uganda', text: 'Uganda' },
    { id: 'Ukraine', text: 'Ukraine' },
    { id: 'United Arab Emirates', text: 'United Arab Emirates' },
    { id: 'United Kingdom', text: 'United Kingdom' },
    { id: 'United States', text: 'United States' },
    { id: 'United States Minor Outlying Islands', 
        text: 'United States Minor Outlying Islands' },
    { id: 'Uruguay', text: 'Uruguay' },
    { id: 'Uzbekistan', text: 'Uzbekistan' },
    { id: 'Vanuatu', text: 'Vanuatu' },
    { id: 'Venezuela', text: 'Venezuela' },
    { id: 'Vietnam', text: 'Vietnam' },
    { id: 'Virgin Islands (British)', text: 'Virgin Islands (British)' },
    { id: 'Virgin Islands (U.S.)', text: 'Virgin Islands (U.S.)' },
    { id: 'Wallis and Futuna Islands', text: 'Wallis and Futuna Islands' },
    { id: 'Western Sahara', text: 'Western Sahara' },
    { id: 'Yemen', text: 'Yemen' },
    { id: 'Yugoslavia', text: 'Yugoslavia' },
    { id: 'Zambia', text: 'Zambia' },
    { id: 'Zimbabwe', text: 'Zimbabwe' }
];


// WEBPACK FOOTER //
// ./src/services/countries/countries.js